
  import * as ipxRuntime$_1BoOXFIC63epbKvUG2oqoyB_qa16IE1_45M3iW5U9i6eY from '/home/vladimir/Desktop/Projekti/marketNew/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$_1BoOXFIC63epbKvUG2oqoyB_qa16IE1_45M3iW5U9i6eY, defaults: {} }
    }
  }
